import React from 'react';

export const PaymentErrorFallback = (
  <div style={{
    padding: '24px',
    textAlign: 'center',
    color: '#333'
  }}>
    <p style={{ fontSize: '16px', marginBottom: '12px' }}>
      Something went wrong loading the payment form.
    </p>
    <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
      Please try refreshing the page, or use the
      Card tab to enter your details manually.
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{
        padding: '12px 24px',
        background: '#000',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px'
      }}
    >
      Refresh page
    </button>
  </div>
);

interface State { hasError: boolean; error?: Error }

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback?: React.ReactNode },
  State
> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? PaymentErrorFallback;
    }
    return this.props.children;
  }
}
